var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateTimeIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 12.2383C29 11.1337 29.8954 10.2383 31 10.2383C32.1046 10.2383 33 11.1337 33 12.2383V16.2383C33 17.3429 32.1046 18.2383 31 18.2383C29.8954 18.2383 29 17.3429 29 16.2383V12.2383Z",
    fill: "#522D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.2383C15 24.686 15.4477 24.2383 16 24.2383H19C19.5523 24.2383 20 24.686 20 25.2383V27.2383C20 27.7906 19.5523 28.2383 19 28.2383H16C15.4477 28.2383 15 27.7906 15 27.2383V25.2383Z",
    fill: "#522D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 32.2383C15 31.686 15.4477 31.2383 16 31.2383H19C19.5523 31.2383 20 31.686 20 32.2383V34.2383C20 34.7906 19.5523 35.2383 19 35.2383H16C15.4477 35.2383 15 34.7906 15 34.2383V32.2383Z",
    fill: "#522D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 24.2383C22.4477 24.2383 22 24.686 22 25.2383V27.2383C22 27.7906 22.4477 28.2383 23 28.2383H26C26.5523 28.2383 27 27.7906 27 27.2383V25.2383C27 24.686 26.5523 24.2383 26 24.2383H23Z",
    fill: "#522D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32.2383C22 31.686 22.4477 31.2383 23 31.2383H26C26.5523 31.2383 27 31.686 27 32.2383V34.2383C27 34.7906 26.5523 35.2383 26 35.2383H23C22.4477 35.2383 22 34.7906 22 34.2383V32.2383Z",
    fill: "#522D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25.2383C29 24.686 29.4477 24.2383 30 24.2383H33C33.5523 24.2383 34 24.686 34 25.2383V27.2383C34 27.7906 33.5523 28.2383 33 28.2383H30C29.4477 28.2383 29 27.7906 29 27.2383V25.2383Z",
    fill: "#522D56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.2383C29.4477 31.2383 29 31.686 29 32.2383V34.2383C29 34.7906 29.4477 35.2383 30 35.2383H33C33.5523 35.2383 34 34.7906 34 34.2383V32.2383C34 31.686 33.5523 31.2383 33 31.2383H30Z",
    fill: "#522D56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.2383H16V16.2383C16 17.8951 17.3431 19.2383 19 19.2383C20.6569 19.2383 22 17.8951 22 16.2383V13.2383H28V16.2383C28 17.8951 29.3431 19.2383 31 19.2383C32.6569 19.2383 34 17.8951 34 16.2383V13.2383H37C38.1046 13.2383 39 14.1337 39 15.2383V37.2383C39 38.3429 38.1046 39.2383 37 39.2383H13C11.8954 39.2383 11 38.3428 11 37.2383V15.2383C11 14.1337 11.8954 13.2383 13 13.2383ZM13 23.2383C13 22.1337 13.8954 21.2383 15 21.2383H35C36.1046 21.2383 37 22.1337 37 23.2383V35.2383C37 36.3429 36.1046 37.2383 35 37.2383H15C13.8954 37.2383 13 36.3429 13 35.2383V23.2383Z",
    fill: "#522D56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.2383C17.8954 10.2383 17 11.1337 17 12.2383V16.2383C17 17.3429 17.8954 18.2383 19 18.2383C20.1046 18.2383 21 17.3429 21 16.2383V12.2383C21 11.1337 20.1046 10.2383 19 10.2383Z",
    fill: "#522D56"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 44.2383,
    x2: 44,
    y2: 44.2383,
    stroke: "#522D56",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTimeIconSelected);
export default __webpack_public_path__ + "static/media/DateTime_icon_selected.3273b1f42e5b9df4879327102cd3bb92.svg";
export { ForwardRef as ReactComponent };